import { Table } from "antd";
import { QRCodeSVG } from 'qrcode.react';
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { getDate } from "../../../utils";
import dayjs from "dayjs";
import { numberToWords } from "../../../utils/helper";
import { useEffect, useState } from "react";

function InvoiceFormatTwo({ invoice }) {

  const [invoiceTotals, setInvoiceTotals] = useState({});

  const buildColumns = () => {
    const allColumns = [
      { title: "Item Description", dataIndex: "product_description" },
      { title: "Quantity", width: 100, dataIndex: "quantity" },
      { title: "Rate", width: 100, dataIndex: "fixed_notified_value_or_retail_price" },
      { title: "Value", width: 130, dataIndex: "value_sales_excluding_st" },
    ];

    return allColumns.map((col) => ({
      ...col,
      render: (text) => {
        // Quantity: show 2 decimals
        if (col.dataIndex === "quantity") {
          return (
            <p style={{ whiteSpace: "nowrap", textAlign: 'right' }}>
              {Number(text).toFixed(2)}
            </p>
          );
        }

        // Columns where word-break is allowed (like Description)
        const breakableCols = ["product_description"];
        if (breakableCols.includes(col.dataIndex)) {
          return (
            <p style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
              {text}
            </p>
          );
        }

        // All other columns: no breaking
        return (
          <p style={{ whiteSpace: "nowrap", textAlign: 'right' }}>
            {text}
          </p>
        );
      },
    }));
  };

  const renderFooterSummary = (data = []) => {
    const numericFields = [
      // "fixed_notified_value_or_retail_price",
      "value_sales_excluding_st",
      "sales_tax_applicable",
      // "sales_tax_with_held_at_source",
      // "further_tax",
      // "fed_payable",
      // "discount",
      "total_values"
    ];

    const totals = {};
    numericFields.forEach((field) => {
      totals[field] = data.reduce((sum, item) => {
        const val = parseFloat(item[field]);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);
    });

    return (
      <Table.Summary fixed>
        <Table.Summary.Row style={{ fontWeight: "bold" }}>
          <Table.Summary.Cell index={0} colSpan={3}>
            <p>
              Value excluding sales tax
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            <p style={{ textAlign: 'right' }}>
              {totals.value_sales_excluding_st.toFixed(2)}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
        <Table.Summary.Row style={{ fontWeight: "bold" }}>
          <Table.Summary.Cell index={0} colSpan={3} >
            Sale Tax {data[0]?.rate}%
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            <p style={{ textAlign: 'right' }}>
              {totals.sales_tax_applicable.toFixed(2)}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
        <Table.Summary.Row style={{ fontWeight: "bold" }}>
          <Table.Summary.Cell index={0} colSpan={3}>
            Value including sales tax
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            <p style={{ textAlign: 'right' }}>
              {totals.total_values.toFixed(2)}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </Table.Summary>
    );
  };

  useEffect(() => {
    const numericFields = [
      "total_values"
    ];
    const totals = {};
    numericFields.forEach((field) => {
      totals[field] = invoice?.invoice_items.reduce((sum, item) => {
        const val = parseFloat(item[field]);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);
    });

    setInvoiceTotals(totals)
  }, [invoice]);

  return (
    <div className="card-body add-product pb-0 px-4">
      <div className="row justify-content-between align-items-center pb-4" style={{ marginTop: '150px' }}>
        <div className="col-lg-4 col-sm-4 col-4">
        </div>
        <div className="col-lg-4 col-sm-4 col-4">
          <h2 className="mt-4 mb-3 text-center">Sales Tax Invoice</h2>
        </div>
        <div className="col-lg-4 col-sm-4 col-4">
          <div className="d-flex justify-content-end align-items-center gap-4">
            <ImageWithBasePath
              src="assets/img/fbr-logo.png"
              alt="img"
              width="110px"
            />
            <QRCodeSVG
              value={invoice?.fbr_invoice_number}
              size={'96px'}
              level="M"
              minVersion={2.0}
            />
          </div>
        </div>
      </div>
      <div className="total-order max-widthauto mb-0 mt-4" style={{ fontSize: "14px" }}>
        <div className="row justify-content-between">
          <div className="col-lg-4 col-sm-4 col-4">
            <strong>Print Date:</strong> {dayjs(new Date()).format('DD-MMM-YYYY hh:mm:ss A')}
          </div>
          <div className="col-lg-5 col-sm-5 col-5 text-end">
            <strong>FBR Invoice No #:</strong> {invoice?.fbr_invoice_number || "-"}
          </div>
        </div>
      </div>
      <div className="emp-details py-1 mt-0 mb-1 px-0" style={{ background: 'transparent', }}>
        <div className="row justify-content-between mb-0">
          <div className="col-lg-7 col-sm-7 col-12 py-1 pe-2">
            <div className="emp-name-id mb-3 px-2 py-1" style={{ backgroundColor: '#fafbfe', border: "1px solid #e9ecef" }}>
              <h5 className="text-center">Buyer Information</h5>
            </div>
            <div className="p-2" style={{ border: '1px solid #000', borderRadius: '10px' }}>
              <div className="emp-name-id mb-1">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-3">
                    <strong>Customer:</strong>
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <p>
                      {invoice?.buyer_business_name}
                    </p>
                  </div>
                </div>
              </div>
              <div className="emp-name-id mb-1">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-3">
                    <strong>Address:</strong>
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <p>
                      {invoice?.buyer_address} {invoice?.buyer_province}
                    </p>
                  </div>
                </div>
              </div>
              <div className="emp-name-id">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-3">
                    <strong>NTN/CNIC:</strong>
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <p>
                      {invoice?.buyer_ntn_cnic || '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-sm-5 col-12 py-1">
            <div className="emp-name-id mb-3 px-2 py-1" style={{ backgroundColor: '#fafbfe', border: "1px solid #e9ecef" }}>
              <h5 className="text-center">Seller Information</h5>
            </div>
            <div className="p-2" style={{ border: '1px solid #000', borderRadius: '10px' }}>
              <div className="emp-name-id mb-1">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-3">
                    <strong>Invoice Ref:</strong>
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <p>
                      {invoice?.invoice_ref_no}
                    </p>
                  </div>
                </div>
              </div>
              <div className="emp-name-id mb-1">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-3">
                    <strong>Date:</strong>
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <p>
                      {getDate(invoice?.invoice_date)}
                    </p>
                  </div>
                </div>
              </div>
              <div className="emp-name-id mb-1">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-3">
                    <strong>Address:</strong>
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <p>
                      {invoice?.seller_address} {invoice?.seller_province}
                    </p>
                  </div>
                </div>
              </div>
              <div className="emp-name-id">
                <div className="row">
                  <div className="col-lg-3 col-sm-3 col-3">
                    <strong>NTN/CNIC:</strong>
                  </div>
                  <div className="col-lg-9 col-sm-9 col-9">
                    <p>
                      {invoice?.seller_ntn_cnic || '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {invoice?.invoice_items.length > 0 &&
        <div className="mb-2 table-responsive">
          <Table
            className="table datanew dataTable no-footer custom-table-2"
            columns={buildColumns(invoice?.invoice_items)}
            dataSource={invoice?.invoice_items}
            pagination={false}
            bordered
            rowClassName={(_, index) => (index === invoice?.invoice_items.length - 1 ? "last-row" : "")}
            summary={() => renderFooterSummary(invoice?.invoice_items)}
          />
        </div>
      }
      <div className="max-widthauto mb-5 mt-0" style={{ fontSize: "14px" }}>
        <div className="row justify-content-between">
          <div className="col-lg-12 col-sm-12 col-12 mb-1">
            <strong>Rupees in words :</strong> {numberToWords(invoiceTotals?.total_values)}
          </div>
          <div className="col-lg-12 col-sm-12 col-12">
            <strong>Payment Terms :</strong> CASH
          </div>
        </div>
      </div>
      <div style={{ height: '100px' }}></div>
      <div className="max-widthauto pb-3" style={{ fontSize: "14px" }}>
        <div className="row justify-content-between">
          <div className="col-lg-4 col-sm-4 col-4">
            <div style={{ border: '1px solid #000', marginBottom: '12px' }}></div>
            <p className="text-center">Prepared By</p>
          </div>
          <div className="col-lg-4 col-sm-4 col-4">
            <div style={{ border: '1px solid #000', marginBottom: '12px' }}></div>
            <p className="text-center">{`For SEPPIC Chemical Industries (Pvt) Ltd`}</p>
          </div>
        </div>
      </div>
      <p className="text-center mt-5 pt-5">This is system generated invoice and does not required any signature and stamp.</p>
    </div>
  );
}

export default InvoiceFormatTwo;
